import classes from "../classes";
import pure from "./higher-order/pure";
import React from "react";

export default pure(function TournamentStatusText({ animated, status }) {
  if (status === "final") {
    return (
      <span className="color--is-lime">
        <i className={classes({
          "dw-flag-checkered": true,
          "animation--is-waving": animated,
          "dw--1-25x": true
        })} />

        {" "}

        <span className="text--is-bold">
          Final!
        </span>
      </span>
    );
  } else if (status === "running") {
    return (
      <span className="color--is-lime">
        <i className="dw-time-slot dw--1-25x" />

        {" "}

        <span className="text--is-bold">
          In Progress
        </span>
      </span>
    );
  } else if (status === "cancelled") {
    return (
      <span className="color--is-error">
        <i className="dw-blocked dw--1-25x" />

        {" "}

        <span className="text--is-bold">
          Cancelled
        </span>
      </span>
    );
  } else if (status === "open" || status === "scheduled") {
    return (
      <span className="color--is-dark-yellow">
        <i className="dw-clock-o dw--1-25x" />

        {" "}

        <span className="text--is-bold">
          Scheduled
        </span>
      </span>
    );
  }
  return (
    <span>
      {status}
    </span>
  );
});
